(function () {
  // mobile menu
  var menuBtn = document.querySelector('[data-menu-btn]');
  var nav = document.querySelector('[data-nav]');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', function () { nav.classList.toggle('open'); });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { nav.classList.remove('open'); });
    });
  }

  // scroll reveal
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = document.querySelectorAll('.reveal');
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.16 });
    els.forEach(function (el) { io.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.add('in'); });
  }
})();

/* Two-dimension sizes, one Shopify option.
   Google Merchant Center only reads a variant option literally named "Size",
   so the coveralls carry ONE option whose values are "44 / Regular". Here we
   split that back into two swatch rows before halford-product.js parses the
   page, so the shopper still picks chest and length separately. Both scripts
   are deferred and this one is first in theme.liquid, so it always wins the
   race. Runs only where every value splits cleanly in two. */
(function () {
  var SPLIT = ' / ';

  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    if (parseInt(root.getAttribute('data-option-count'), 10) !== 1) return;

    var dataEl = root.querySelector('[data-variant-json]');
    var group  = root.querySelector('.vopt');
    if (!dataEl || !group || !group.parentNode) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var splittable = variants.every(function (v) {
      return v && typeof v.options[0] === 'string' &&
             v.options[0].split(SPLIT).length === 2;
    });
    if (!splittable) return;

    var labels = (root.getAttribute('data-split-labels') || 'Chest|Length').split('|');
    var dims = [[], []];

    variants.forEach(function (v) {
      v.options = v.options[0].split(SPLIT);
      v.options.forEach(function (val, i) {
        if (dims[i].indexOf(val) === -1) dims[i].push(val);
      });
    });

    dataEl.textContent = JSON.stringify(variants);
    root.setAttribute('data-option-count', '2');

    var frag = document.createDocumentFragment();
    dims.forEach(function (vals, i) {
      var g = document.createElement('div');
      g.className = 'vopt';

      var lab = document.createElement('div');
      lab.className = 'vopt-label';
      var name = document.createElement('span');
      name.textContent = labels[i] || ('Option ' + (i + 1));
      var picked = document.createElement('span');
      picked.className = 'picked';
      picked.setAttribute('data-picked', '');
      lab.appendChild(name);
      lab.appendChild(picked);

      var wrap = document.createElement('div');
      wrap.className = 'vswatches';
      vals.forEach(function (val) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vswatch';
        b.setAttribute('data-opt', String(i));
        b.setAttribute('data-value', val);
        b.setAttribute('aria-pressed', 'false');
        b.textContent = val;
        wrap.appendChild(b);
      });

      g.appendChild(lab);
      g.appendChild(wrap);
      frag.appendChild(g);
    });

    group.parentNode.replaceChild(frag, group);
  });
})();
